/**
 * Адрес админки — panel.padla.pro (решение ректора 26 сен 2026). Одна правда для шлюза (проверка
 * `Origin`, rpID ключей, кука) и панели (где вообще предлагать вход ключом): ключ, привязанный к
 * этому имени, на другом адресе браузер не покажет вовсе.
 *
 * Это не рабочая настройка, а устройство: к этому имени привязываются ключи доступа админов
 * (WebAuthn rpID), и сменить его — значит перевыпустить все ключи. Поэтому константа, а не
 * переменная окружения или горячая настройка (П26 касается значений, которые меняют у живой
 * системы; это меняют миграцией).
 *
 * Сама машина отвечает на это имя (DNS → 172.239.224.217, TLS — NPM на ней же). Остальные адреса
 * панели из `CORS_ORIGIN` (ru.panel.padla.pro → kubik) — мосты: TLS на них снимает другая машина,
 * поэтому админки через них нет (пункт 5 спеки docs/superpowers/specs/2026-09-26-admin-passkey-access-verification.md).
 */
export const ADMIN_ORIGIN = 'https://panel.padla.pro';
export const ADMIN_HOST = new URL(ADMIN_ORIGIN).hostname;
//# sourceMappingURL=admin-origin.js.map